"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestRequirementType = exports.QuestRewardType = void 0;
var QuestRewardType;
(function (QuestRewardType) {
    QuestRewardType["XP"] = "xp";
    QuestRewardType["Gold"] = "gold";
    QuestRewardType["Silver"] = "silver";
    QuestRewardType["Reputation"] = "reputation";
    QuestRewardType["Stat"] = "stat";
    QuestRewardType["HolidayTokens"] = "holidayTokens";
})(QuestRewardType || (exports.QuestRewardType = QuestRewardType = {}));
var QuestRequirementType;
(function (QuestRequirementType) {
    QuestRequirementType["Kill"] = "kill";
    QuestRequirementType["Item"] = "item";
    QuestRequirementType["None"] = "none";
    QuestRequirementType["Count"] = "count";
    QuestRequirementType["Array"] = "array";
})(QuestRequirementType || (exports.QuestRequirementType = QuestRequirementType = {}));
